export default (data, cleanData, schema) => {
    return Object.keys(cleanData).reduce((newData, key) => {
        if (
            schema.properties?.[key]?.type?.[0] === 'array' &&
            schema.properties?.[key]?.items?.type === 'integer' &&
            data[key] &&
            data[key].length
        ) {
            newData[key] = data[key];
        } else if (
            schema.properties?.[key]?.type?.[0] === 'integer' &&
            (data?.[key]?.value || data?.[key]?.value === 0)
        ) {
            newData[key] = data[key];
        }

        return newData;
    }, cleanData);
};
